import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _class, _class2, _temp;

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import Tabs from './tabs';
import { get } from 'lodash';

var TabsStateful = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TabsStateful, _PureComponent);

  function TabsStateful(props) {
    var _this;

    _classCallCheck(this, TabsStateful);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabsStateful).call(this, props));
    _this.state = {
      activeTab: props.initialTab ? props.initialTab : get(props, 'items.length') ? get(props, 'items[0].name') : null
    };
    return _this;
  }

  _createClass(TabsStateful, [{
    key: "onChange",
    value: function onChange(_ref) {
      var name = _ref.name;
      this.setState({
        activeTab: name
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          initialTab = _this$props.initialTab,
          rest = _objectWithoutProperties(_this$props, ["initialTab"]);

      return React.createElement(Tabs, _extends({}, rest, {
        activeTab: this.state.activeTab,
        onChange: this.onChange
      }));
    }
  }]);

  return TabsStateful;
}(PureComponent), _defineProperty(_class2, "propTypes", {
  initialTab: PropTypes.string,
  items: PropTypes.array
}), _temp)) || _class;

export default TabsStateful;